// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__R-nVH","content":"styles_content__11c7I","checkbox":"styles_checkbox__KvnLC","checkboxLabel":"styles_checkboxLabel__3rS84"};